module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/parts/b-select/b-select.component.css
// module id = ./src/app/parts/b-select/b-select.component.css
// module chunks = main